import React, { useEffect }from 'react';
import PropTypes from 'prop-types';
import { MidBannerAdWrapper } from './ad.style';
import { getAdsConfig } from '@gameday/utils/selectors/getAdsConfig'
import { useSelector } from 'react-redux';
import { BannerWrapper } from './ad.style';
import useAds from '@gameday/utils/hooks/useAds';

const drawAd = (ads, drawSingleAd, doubleclickGetGptadslots, startRefreshMidInningAdTimer) => {
    if (ads) {
        for (let i = 0; i < ads.length; i++) {
            const adUnit = ads[i];
            const { container } = adUnit; 
            const dom = document.querySelector('#'+ container);
            const existedAd = doubleclickGetGptadslots()?.[container];
            if (dom && !existedAd) {
                drawSingleAd(adUnit);
                startRefreshMidInningAdTimer(adUnit);
            }   
        }
    }
};

const DisplayAd = ({
    viewType,
    adId
}) => {
    const AdsInfo = useAds();
    const { drawSingleAd, doubleclickGetGptadslots, startRefreshMidInningAdTimer, stopRefreshMidInningAdTimer } = AdsInfo?.adEngine?.doubleclick || {};
    const { adsConfig = {} } = useSelector(getAdsConfig);
    const { units } = adsConfig;
    const ad = units?.[adId];
    const ads = (typeof ad !== 'undefined') ? (Array.isArray(ad) ? ad : [ad] ): undefined;
  
    useEffect(() => {
        
        if (!ads) {
            return;
        }
    
        drawAd(ads, drawSingleAd, doubleclickGetGptadslots, startRefreshMidInningAdTimer);
        
        return () => {
            stopRefreshMidInningAdTimer(); 
        };

    }, [ads, drawSingleAd, doubleclickGetGptadslots, startRefreshMidInningAdTimer, stopRefreshMidInningAdTimer]);


    return (
        <>
            <MidBannerAdWrapper $type={viewType}>
                <BannerWrapper id={`gameday-index-component__${adId}`}>
                    <div className={`ad-responsive-slot`}>
                        {ads.map((data, index) => {
                            const {
                                container = '',
                                sizes = [],
                                thresholds = [],
                                targeting: { pos } = {}
                            } = data;
                            
                            return (
                                <div
                                    id={container}
                                    key={`${adId}-${index}`}
                                    className="ad-responsive-size"
                                    data-thresholds={thresholds}
                                    data-sizes={sizes}
                                    data-targeting={`{ pos: ${pos}, content: "gameday"}`}
                                />
                            );
                        })}
                    </div>
                </BannerWrapper>
            </MidBannerAdWrapper>
        </>
    )
};

DisplayAd.propTypes = {
    viewType: PropTypes.string,
    adId: PropTypes.string
};

export default DisplayAd;